// alert("script_connected");
const pincodeCheckText = document.getElementById("pincode_check_msg");
pincodeCheckText.style.display = 'none';
$(document).on("click","#disabled_popup_button",function() {
  pincodeCheckText.style.display = 'none';
          setTimeout(() => {
            pincodeCheckText.style.display = 'none';
          }, 3000);
 });
const cod = 0;
var weight = document.getElementById("product-data").getAttribute("data-weight");
weight = weight/1000;

let apiurl = "https://ship.endurasupplements.com/api/pincode-checker";
const particularButton = document.getElementById("disabled_button");
// particularButton.classList.add('disabledButtonCart');
// particularButton.style.display = 'none';
const pinCodeFunction = async () => {
  const disabled_button = document.getElementById('disabled_button')
// disabled_button.classList.add('disabledButtonCart');
console.log("disabled_button",disabled_button)
  // alert("")
   let e = document.getElementById("successMessage");
   e.innerHTML = "";
   let t = document.createElement("p"),
      n = document.createElement("p"),
      d = document.getElementById("errorMessage"),
      l = document.getElementById("pincode").value;
   d.innerHTML = "";
   let i = document.createElement("p");
   if (i.setAttribute("class", "errorMesclass"), isNaN(l)) i.innerHTML = "Kindly Enter Valid Pincode", d.appendChild(i), document.getElementById("disabled_button").disabled = !0;
   else if (/^\d{6}$/.test(l)) {
      let o = document.getElementById("pinCode_button");
      o.textContent = "EDIT";
      let r = {
         delivery_postcode: l,
         weight: weight,
         cod: 0
      };
      console.log(r), fetch(apiurl, {
         method: "POST",
         headers: {
            "Content-Type": "application/json"
         },
         body: JSON.stringify(r)
      }).then(e => e.json()).then(o => {
         console.log(o), "No Delivery Available" == o.message ? (document.getElementById("errorMessage").innerHTML = o.message, d.appendChild(i), document.getElementById("disabled_button").disabled = !0,disabled_button.classList.add('comm_d_none'), document.getElementById("disabled_popup_button").style.display = 'block') : (t.innerHTML = o.title, n.innerHTML = handleResponseFn(o.message), t.style.color = "green", n.style.color = "black", e.appendChild(t), e.appendChild(n), document.getElementById("disabled_button").disabled = !1,disabled_button.classList.remove('comm_d_none'), document.getElementById("disabled_popup_button").style.display = 'none', localStorage.setItem("PINCODE", l))
      }).catch(e => {
         console.error("Error:", e)
          })
             .finally(() => {
    pinCode_button.removeAttribute("disabled");
               // console.log("Api call completed")
      }), finalDeliverydate(l)
   } else "" == l ? (i.innerHTML = "Please enter a valid pincode", d.appendChild(i), document.getElementById("disabled_button").disabled = !0, document.getElementById("disabled_popup_button").style.display = 'block',disabled_button.classList.add('comm_d_none')) : (i.innerHTML = "Invalid Pincode", d.appendChild(i), document.getElementById("disabled_button").disabled = !0)
}, finalDeliverydate = e => {
   myFunction()
}, myFunction = () => {
   let e = document.getElementById("pincode").value;
   e > 0 ? console.log("button will be visible") : console.log("not visible")
}, inputField = document.querySelector(".userPincode"), storedPinCode = localStorage.getItem("PINCODE");
storedPinCode && (document.getElementById("pincode").value = storedPinCode, console.log("pincode their in local storage"), document.getElementById("errorMessage").innerHTML = "", pinCodeFunction());
var el = document.querySelector("#pincode");
el.addEventListener("focus", e => {
   document.querySelector("#pinCode_button").innerHTML = "CHECK"
}), el.addEventListener("focusout", e => {
   document.querySelector("#pinCode_button").innerHTML = "EDIT"
});

function handleResponseFn(responseTitle){
  const responTitleSplit = responseTitle.split(" ")[2];
  if(responTitleSplit.split("-")[1].split("").length > 4){
    // console.log("not return");
    return "Expected within 6-8 days";
    return 
  } else{
    return responseTitle;
  }
}